import React from "react";
import { Link } from "react-router-dom";
import "../CSS/VisaServices.css";
import heroBg from "../Assets/bgimage.jpg";
import visaImg from "../Assets/visa1.jpg";
import frroImg from "../Assets/Visa2.jpg";
// import coupleVisaImg from "../Assets/couple-visa.jpg";
import { 
  FaAngleRight, 
  FaCheckCircle, 
  FaClock, 
  FaPassport,
  FaGlobe,
  FaFileAlt,
  FaUserFriends,
  FaHeart,
  FaBuilding,
  FaRegFileAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowRight,
  FaShieldAlt,
  FaHandshake,
  FaRegClock,
  FaCalendarAlt,
  FaFileSignature,
  FaIdCard
} from "react-icons/fa";

export default function VisaServices() {
  const heroStyle = {
    backgroundImage: `url(${heroBg})`,
  };

  const visaServices = [
    {
      title: "Tourist Visa",
      description: "For leisure travel, sightseeing, and visiting friends/family abroad.",
      documents: ["Valid Passport (6 months validity)", "Recent Photographs", "Flight Itinerary", "Hotel Booking", "Bank Statements", "Travel Insurance"],
      processingTime: "5-7 Working Days",
      icon: <FaGlobe />
    },
    {
      title: "Business Visa",
      description: "For attending meetings, conferences, or business negotiations overseas.",
      documents: ["Valid Passport", "Invitation Letter", "Company Letter", "Bank Statements", "Tax Returns", "Business Registration"],
      processingTime: "7-10 Working Days",
      icon: <FaBuilding />
    },
    {
      title: "Student Visa",
      description: "For pursuing education at foreign universities and institutions.",
      documents: ["Valid Passport", "University Offer Letter", "Financial Proof", "Academic Documents", "IELTS/TOEFL Score", "Visa Application Form"],
      processingTime: "10-15 Working Days",
      icon: <FaFileAlt />
    },
    {
      title: "Work Visa",
      description: "For employment opportunities in foreign countries.",
      documents: ["Valid Passport", "Employment Contract", "Company Sponsorship", "Educational Certificates", "Experience Letters", "Medical Certificate"],
      processingTime: "10-15 Working Days",
      icon: <FaHandshake />
    },
    {
      title: "Medical Visa",
      description: "For seeking medical treatment at recognized hospitals abroad.",
      documents: ["Valid Passport", "Medical Reports", "Hospital Invitation", "Treatment Plan", "Financial Proof", "Attendant Documents"],
      processingTime: "5-7 Working Days",
      icon: <FaShieldAlt />
    },
    {
      title: "Conference Visa",
      description: "For attending international conferences, seminars, and workshops.",
      documents: ["Valid Passport", "Conference Invitation", "Registration Proof", "Company Letter", "Travel Itinerary", "Accommodation Details"],
      processingTime: "7-10 Working Days",
      icon: <FaRegFileAlt />
    }
  ];

  const frroServices = [
    {
      title: "FRRO Registration",
      description: "Foreigners Regional Registration Office registration for international visitors staying beyond permitted period.",
      documents: ["Passport with Valid Visa", "Residential Proof", "Photographs", "Arrival Details", "Sponsor Details"],
      processingTime: "3-5 Working Days",
      icon: <FaIdCard />
    },
    {
      title: "FRRO Visa Extension",
      description: "Extension of visa for international students, professionals, and tourists.",
      documents: ["Original Passport", "Current Visa", "Extension Reason Letter", "Financial Proof", "Accommodation Proof"],
      processingTime: "5-7 Working Days",
      icon: <FaRegClock />
    },
    {
      title: "FRRO Exit Permit",
      description: "Exit permit required for certain visa categories before leaving India.",
      documents: ["Passport", "Visa Documents", "Exit Reason Letter", "No Dues Certificate", "Flight Ticket"],
      processingTime: "3-5 Working Days",
      icon: <FaCalendarAlt />
    }
  ];

  const coupleVisaServices = [
    {
      title: "Spouse Visa",
      description: "For married couples where one spouse is a foreign national or living abroad.",
      documents: ["Marriage Certificate", "Passport Copies", "Photographs", "Proof of Relationship", "Financial Documents", "Accommodation Proof"],
      processingTime: "10-15 Working Days",
      icon: <FaHeart />
    },
    {
      title: "Dependent Visa",
      description: "For dependents of foreign nationals working or studying in India/abroad.",
      documents: ["Valid Passport", "Relationship Proof", "Sponsor Documents", "Financial Proof", "Medical Certificate"],
      processingTime: "7-10 Working Days",
      icon: <FaUserFriends />
    },
    {
      title: "Fiancé Visa",
      description: "For engaged couples planning to marry a foreign national.",
      documents: ["Passport", "Engagement Proof", "Photographs", "Communication Proof", "Financial Documents", "Wedding Plans"],
      processingTime: "10-15 Working Days",
      icon: <FaHeart />
    }
  ];

  return (
    <div className="visa-page">

      {/* HERO SECTION */}
      <section className="visa-hero-section" style={heroStyle}>
        <div className="visa-hero-overlay" />
        <div className="visa-hero-wrapper">
          <div className="visa-hero-content">
            <h1 className="visa-hero-title">Visa &amp; FRRO Services</h1>
            <div className="visa-hero-breadcrumb">
              <Link to="/">Home</Link>
              <span className="visa-breadcrumb-sep"><FaAngleRight /></span>
              <span className="visa-breadcrumb-current">Visa Services</span>
            </div>
          </div>
        </div>
      </section>

      {/* INTRODUCTION SECTION */}
      <section className="visa-intro-section">
        <div className="visa-container">
          <div className="visa-intro-grid">
            <div className="visa-intro-text">
              <div className="visa-section-tag">VISA ASSISTANCE</div>
              <h2 className="visa-section-title">Comprehensive Visa &amp; FRRO Services</h2>
              <p className="visa-intro-paragraph">
                We provide end-to-end visa assistance, FRRO registration, and couple visa services for individuals, families, 
                and businesses. Our expert team handles all documentation, form filling, and follow-ups with embassies and 
                government authorities to ensure a smooth and hassle-free process.
              </p>
              
              {/* Contact Cards */}
              <div className="visa-contact-mini-cards">
                <a href="tel:+916393244687" className="visa-contact-mini-card">
                  <div className="visa-mini-icon"><FaPhoneAlt /></div>
                  <div className="visa-mini-info">
                    <span className="visa-mini-label">Call Us</span>
                    <span className="visa-mini-value">+91 6393244687</span>
                  </div>
                </a>
                <a href="mailto:info@apostilleserviceinmumbai.com" className="visa-contact-mini-card">
                  <div className="visa-mini-icon"><FaEnvelope /></div>
                  <div className="visa-mini-info">
                    <span className="visa-mini-label">Email Us</span>
                    <span className="visa-mini-value">info@apostilleserviceinmumbai.com</span>
                  </div>
                </a>
              </div>

              <div className="visa-processing-badge">
                <FaClock className="visa-time-icon" />
                <span>Processing Time: <strong>Varies by Visa Type</strong></span>
              </div>
            </div>
            <div className="visa-intro-image">
              <img src={visaImg} alt="Visa Services" />
            </div>
          </div>
        </div>
      </section>

      {/* VISA SERVICES SECTION */}
      <section className="visa-services-section">
        <div className="visa-container">
          <div className="visa-section-header">
            <span className="visa-section-tag">VISA TYPES</span>
            <h2 className="visa-section-title">Visa Services We Offer</h2>
            <p className="visa-section-description">Comprehensive visa assistance for all purposes</p>
          </div>

          <div className="visa-services-grid">
            {visaServices.map((service, index) => (
              <div className="visa-service-card" key={index}>
                <div className="visa-service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p className="visa-service-desc">{service.description}</p>
                <div className="visa-service-time">
                  <FaRegClock className="visa-time-small" />
                  <span>{service.processingTime}</span>
                </div>
                <details className="visa-service-details">
                  <summary>Required Documents</summary>
                  <ul>
                    {service.documents.map((doc, i) => (
                      <li key={i}><FaCheckCircle className="visa-check-icon" /> {doc}</li>
                    ))}
                  </ul>
                </details>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FRRO SERVICES SECTION */}
      <section className="visa-frro-section">
        <div className="visa-container">
          <div className="visa-section-header">
            <span className="visa-section-tag">FRRO SERVICES</span>
            <h2 className="visa-section-title">FRRO Registration &amp; Support</h2>
            <p className="visa-section-description">Complete assistance for foreigners in India</p>
          </div>

          <div className="visa-frro-grid">
            {frroServices.map((service, index) => (
              <div className="visa-frro-card" key={index}>
                <div className="visa-frro-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p className="visa-frro-desc">{service.description}</p>
                <div className="visa-frro-time">
                  <FaRegClock className="visa-time-small" />
                  <span>{service.processingTime}</span>
                </div>
                <details className="visa-frro-details">
                  <summary>Required Documents</summary>
                  <ul>
                    {service.documents.map((doc, i) => (
                      <li key={i}><FaCheckCircle className="visa-check-icon" /> {doc}</li>
                    ))}
                  </ul>
                </details>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COUPLE VISA SERVICES SECTION */}
      <section className="visa-couple-section">
        <div className="visa-container">
          <div className="visa-section-header">
            <span className="visa-section-tag">COUPLE VISA</span>
            <h2 className="visa-section-title">Couple &amp; Family Visa Services</h2>
            <p className="visa-section-description">Visa assistance for couples and families</p>
          </div>

          <div className="visa-couple-grid">
            {coupleVisaServices.map((service, index) => (
              <div className="visa-couple-card" key={index}>
                <div className="visa-couple-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p className="visa-couple-desc">{service.description}</p>
                <div className="visa-couple-time">
                  <FaRegClock className="visa-time-small" />
                  <span>{service.processingTime}</span>
                </div>
                <details className="visa-couple-details">
                  <summary>Required Documents</summary>
                  <ul>
                    {service.documents.map((doc, i) => (
                      <li key={i}><FaCheckCircle className="visa-check-icon" /> {doc}</li>
                    ))}
                  </ul>
                </details>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section className="visa-why-section">
        <div className="visa-container">
          <div className="visa-why-grid">
            <div className="visa-why-content">
              <span className="visa-section-tag">WHY CHOOSE US</span>
              <h2 className="visa-section-title">Expert Visa &amp; FRRO Assistance</h2>
              <ul className="visa-why-list">
                <li><FaCheckCircle className="visa-why-icon" /> Experienced visa consultants with 10+ years of expertise</li>
                <li><FaCheckCircle className="visa-why-icon" /> End-to-end documentation and form filling support</li>
                <li><FaCheckCircle className="visa-why-icon" /> Direct coordination with embassies and FRRO offices</li>
                <li><FaCheckCircle className="visa-why-icon" /> Real-time application tracking and updates</li>
                <li><FaCheckCircle className="visa-why-icon" /> Affordable pricing with transparent fee structure</li>
                <li><FaCheckCircle className="visa-why-icon" /> High success rate for visa approvals</li>
              </ul>
            </div>
            <div className="visa-why-image">
              <img src={frroImg} alt="Why Choose Us" />
            </div>
          </div>
        </div>
      </section>

      {/* PROCESS STEPS */}
      <section className="visa-steps-section">
        <div className="visa-container">
          <div className="visa-section-header light">
            <span className="visa-section-tag">SIMPLE PROCESS</span>
            <h2 className="visa-section-title">How We Help You</h2>
            <p className="visa-section-description">Simple steps to get your visa processed</p>
          </div>

          <div className="visa-steps-grid">
            <div className="visa-step-card">
              <div className="visa-step-number">1</div>
              <div className="visa-step-content">
                <h4>Free Consultation</h4>
                <p>Discuss your visa requirements with our experts</p>
              </div>
            </div>
            <div className="visa-step-card">
              <div className="visa-step-number">2</div>
              <div className="visa-step-content">
                <h4>Document Collection</h4>
                <p>We help you gather all required documents</p>
              </div>
            </div>
            <div className="visa-step-card">
              <div className="visa-step-number">3</div>
              <div className="visa-step-content">
                <h4>Form Filling & Submission</h4>
                <p>Complete visa forms and submit to authorities</p>
              </div>
            </div>
            <div className="visa-step-card">
              <div className="visa-step-number">4</div>
              <div className="visa-step-content">
                <h4>Follow-up & Delivery</h4>
                <p>Track application and get visa delivered</p>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* CTA SECTION */}
      <section className="visa-cta-section">
        <div className="visa-container">
          <h2 className="visa-cta-title">Need Visa Assistance?</h2>
          <p className="visa-cta-description">Get expert guidance for your visa, FRRO, or couple visa requirements</p>
          <div className="visa-cta-buttons">
            <Link to="/contact" className="visa-btn-primary">
              Contact Us <FaArrowRight />
            </Link>
            <a href="tel:+916393244687" className="visa-btn-secondary">
              Call Now <FaPhoneAlt />
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}